import { z } from 'zod';
import { createErrorHandler } from './helpers/error-handler';
export const urlValidator = ({ requiredError, formatError, }) => {
    const validator = z.url({
        error: createErrorHandler(requiredError, formatError),
    });
    if (!requiredError) {
        validator.optional();
    }
    return validator;
};
